module.exports = __webpack_public_path__ + "img/img_clients4.f7bcbcbe.jpg";